export const ACCOUNT = "Счёт";

export const PERCENTS_FOR_STEP = 25;
